import { Filters } from '@/core/collections/filters/filter.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import address, { AddressState } from './addresses/address.store';
import { CompanyService } from '../companies/company.service';
import { Company } from '../companies/company.interface';

const service = new CompanyService();

export interface CompanyState {
   filters?: Filters;
   activeIndex?: number;

   //modules
   address?: AddressState;
}

const Companiestore: Module<CompanyState, StoreState> = {
   namespaced: true,
   state: {
      filters: { quick_search: [], filter_elements: [] },
      activeIndex: 0,
   },
   getters: {
      filters: (state) => state.filters,
      activeIndex: (state) => state.activeIndex,
   },
   mutations: {},
   actions: {
      async getCompanies(context, query: LocationQuery) {
         const response = await service.getCompanies({ ...query });
         return response;
      },
      async searchCompanies(context, query: LocationQuery) {
         const response = await service.getCompanies({ ...query });
         return response.data;
      },
      async createCompany(context, company: Company) {
         const response = await service.postCompany(company);
         return response.data;
      },
      async searchCompanyNumber(context, payload: { company_number: number; country_id: number }) {
         const response = await service.searchCompanyNumber(payload.company_number, payload.country_id);
         return response;
      },
      async searchCompanyName(context, payload: { company_name: string; country_id: number }) {
         const response = await service.searchCompanyName(payload.company_name, payload.country_id);
         return response;
      },
   },
   modules: {
      address,
   },
};

export default Companiestore;
